











import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Guests from '@/services/Guests'
import agora from '@/services/Agora'

@Component
export default class ParticipateButton extends Vue {
  @Prop({ required: true }) public value!: boolean
  @Prop({ required: true }) public waiterId!: string
  @Prop({ required: true }) public waiterName!: string
  @Prop({ required: true }) public restaurantId!: string
  @Prop({ required: true }) public activeRoomId!: string
  @Prop({ required: true }) public activeSeatingId!: string

  public isParticipating = this.value

  async participateInRoom() {
    // Create the waiter as guest
    await Guests.createWaiterGuest(
      this.restaurantId,
      this.activeSeatingId,
      this.activeRoomId,
      this.waiterId,
      this.waiterName ? `${this.waiterName} (jij)` : null
    )

    // Join the channel
    const channelId = `${this.restaurantId}:${this.activeSeatingId}:${this.activeRoomId}`
    await agora.join(channelId, this.waiterId)

    // Signal we're ready to stream
    await Guests.setGuestOnAgora(this.restaurantId, this.activeSeatingId, this.waiterId, true)

    // Create the local stream
    agora.createStream('local_waiter_stream')

    // todo: fix this
    setTimeout(() => {
      this.isParticipating = true
    }, 500)
  }

  async stopParticipation() {
    this.isParticipating = false

    await Guests.setGuestOnAgora(this.restaurantId, this.activeSeatingId, this.waiterId, false)
    await Guests.removeWaiterGuest(this.restaurantId, this.activeSeatingId, this.waiterId)

    this.$emit('initRoom')
  }

  @Watch('isParticipating')
  HandleParticipatingChange() {
    this.$emit('input', this.isParticipating)
  }
}
